exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-heading{margin-bottom:2.5rem\n}\n@media(max-width: 1024px){\n.page-heading{margin-bottom:1rem\n}\n}\n.recurso-post-title{font-size:2.25rem;padding-bottom:2.5rem\n}\n@media(max-width: 1024px){\n.recurso-post-title{font-size:1.75rem\n}\n}\n.recommended-title{font-size:2rem;padding-bottom:3.5rem;font-weight:bold\n}\n.article h3.title-article{padding-bottom:1em\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ec513ec","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/resources/ResourcesEntrada.vue
// module id = X1oA
// module chunks = 1